import React from "react";
import { cn } from "./../../../Utils/helper/index";

export function FormField({
  icon,
  iconName,
  placeholder,
  rightIcon,
  value,
  onChange,
  name,
  type = "text",
  className,
  classNameImageLeft,
  classNameImageRight,
  classNameInput,
  numeric = false,
  maxLength,
  classNameText,
  ...props
}) {
  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    if (numeric) {
      inputValue = inputValue.replace(/[^0-9]/g, "");
    }

    if (maxLength && inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }

    if (onChange) {
      e.target.value = inputValue;
      onChange(e);
    }
  };

  return (
    <div
      className={cn(
        "flex gap-2 items-center px-3 h-[50px] w-full bg-white rounded-lg border border-solid border-light-grey",
        className
      )}
    >
      {icon && (
        <img
          loading="lazy"
          src={icon}
          alt=""
          className={cn("object-contain shrink-0 self-stretch my-auto w-5", classNameImageLeft)}
        />
      )}
      {iconName && (
        <div className="w-6 flex justify-center items-center">
          <span className={`icon icon-${iconName} text-xl text-mid-gray`} />
        </div>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        name={name}
        className={cn(
          "flex-1 bg-transparent border-none outline-none text-base text-black",
          classNameInput
        )}
        maxLength={maxLength}
        {...props}
      />
      {rightIcon && (
        <img
          loading="lazy"
          src={rightIcon}
          alt=""
          className={cn(
            "object-contain shrink-0 self-stretch my-auto w-5 placeholder:text-mid-gray",
            classNameImageRight
          )}
        />
      )}
    </div>
  );
}
